import {mapState} from 'vuex'

export default mapState({
    user: state => state.session.user
})
